export const serverURL = "https://sky-chat-backend.onrender.com";